import { Formik } from 'formik';
import React from 'react';

import AutocompleteField from '@components/Form/AutocompleteField';
import { AutocompleteOption } from '@utils/interfaces';

interface SearchProps {
  companyNamesOptions: AutocompleteOption[];
  hasCategoryHeader?: boolean;
}

const Search = ({ companyNamesOptions, hasCategoryHeader = false }: SearchProps) => {
  const handleSelect = (companyName: string) => {
    const row = companyName.replaceAll(/[.()-]/g, '');
    const el = document.querySelector(`tr[data-company="${row}"]`) as HTMLElement;
    if (!el) return;

    const top = el.getBoundingClientRect().top + window.scrollY - (hasCategoryHeader ? 80 : 40);
    window.scrollTo({ top, behavior: 'smooth' });
    el.click();
  };

  return (
    <div className="mx-auto mb-12 hidden w-3/4 sm:block md:w-2/5">
      <Formik
        enableReinitialize
        initialValues={{ 'company-search': { label: '', value: '' } }}
        onSubmit={null}
      >
        {() => (
          <AutocompleteField
            isCreatable={false}
            label="Search"
            name="company-search"
            placeholder="Search company names"
            options={companyNamesOptions}
            onChange={(option) => handleSelect(option?.label || '')}
          />
        )}
      </Formik>
    </div>
  );
};

export default Search;
